module.exports = require("conventional-changelog-core");


//////////////////
// WEBPACK FOOTER
// external "conventional-changelog-core"
// module id = 93
// module chunks = 0